import { ArchivoSolDevoDto, ArchivoGenDto } from 'libs/ciptech-commons/src/lib/dto'

export class ArchivoBuilder {
	static fromArchivoSolDevoDto(dto: ArchivoSolDevoDto): ArchivoGenDto {
		return {
			NombreOriginal: dto.NombreOriginal,
			NombreFisico: dto.CodigoArchivo,
			Peso: dto.Peso,
			Extension: dto.Extension
		}
	}

	static fromArchivoSolDevoDtoList(
		lista: ArchivoSolDevoDto[]
	): ArchivoGenDto[] {
		return lista.map(x => this.fromArchivoSolDevoDto(x));
	}
}